import { render, staticRenderFns } from "./Baccarat2.vue?vue&type=template&id=38ca3b8c&scoped=true"
import script from "./Baccarat2.vue?vue&type=script&lang=js"
export * from "./Baccarat2.vue?vue&type=script&lang=js"
import style0 from "./Baccarat2.vue?vue&type=style&index=0&id=38ca3b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca3b8c",
  null
  
)

export default component.exports